function BulkPaymentLinkList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

BulkPaymentLinkList.prototype = Object.assign(BulkPaymentLinkList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.bulkPaylinkFileProcessDto &&
            tableData.bulkPaylinkFileProcessDto.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            requestId,
            requestPurpose,
            merchantId,
            validCount,
            invalidCount,
            status,
            remark,
        } = row;
        return {
            requestId,
            requestPurpose,
            merchantId,
            validCount,
            invalidCount,
            status,
            remark,
        };
    },
});

export default BulkPaymentLinkList;
